import React from "react";

export interface SkeletonProps {
  /** Optional className for size/shape (e.g. h-4 w-32, rounded-full) */
  className?: string;
}

/**
 * Shared skeleton placeholder with pulse animation.
 * Use across client dashboard for consistent loading states.
 */
export function Skeleton({ className = "" }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded bg-neutral-200 ${className}`}
      aria-hidden
    />
  );
}
